export default "__VITE_ASSET__78358ead__$_?component__"